import { useMemo } from "react";
import useFetch from "./use-fetch";

export default function useVerifySpecExists(path: string) {
  const fetchOptions = useMemo(() => ({ method: "HEAD", json: false }), []);
  const { loading, status } = useFetch(path, fetchOptions);

  return loading ? null : status === 200;
}
